import { businessKey } from 'queryKeys';

export const APPLICATIONS = 'Applications';
export const applicationsQuery = businessKey.query(APPLICATIONS);

export const grid = applicationsQuery.grid();

export const model = applicationsQuery.exact();

export const mutations = applicationsQuery.mutations();

export const update = mutations.update();
